import { useGetUserInfo } from "@/features/auth/services/userinfo";
import { userInfoAtom } from "@/store/userinfo";
import { useAtom } from "jotai";

const useUserInfo = () => {
  const [userInfo, setUserInfo] = useAtom(userInfoAtom);
  const { refetch: refetchUserInfo } = useGetUserInfo.useQueryHook({
    params: {},
    queryConfig: { enabled: false },
  });
  const freshUserInfo = async () => {
    const result = await refetchUserInfo();
    setUserInfo(result.data || null);
  };
  return {
    userInfo,
    freshUserInfo,
  };
};

export default useUserInfo;